import { api } from './api';
import { DailyReport, ApiResponse } from '../types/api';

export const dailyReportsAPI = {
  getReports: async (): Promise<ApiResponse<DailyReport>> => {
    const response = await api.get<ApiResponse<DailyReport>>('/daily-reports');
    return response.data;
  },

  getReport: async (id: number): Promise<DailyReport> => {
    const response = await api.get<DailyReport>(`/daily-reports/${id}`);
    return response.data;
  },

  createReport: async (formData: FormData): Promise<DailyReport> => {
    const response = await api.post<DailyReport>('/daily-reports', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  updateReport: async (id: number, formData: FormData): Promise<DailyReport> => {
    const response = await api.put<DailyReport>(`/daily-reports/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  deleteReport: async (id: number): Promise<void> => {
    await api.delete(`/daily-reports/${id}`);
  },

  getNextReportNumber: async (projectId: number): Promise<string> => {
    const response = await api.get<{ next_number: string }>('/daily-reports/next-number', {
      params: { project_id: projectId }
    });
    return response.data.next_number;
  },

  getWeatherForAddress: async (address: string, date?: string): Promise<any> => {
    const response = await api.get<any>('/daily-reports/weather', {
      params: { address, ...(date ? { date } : {}) }
    });
    return response.data;
  },

  uploadPhotos: async (id: number, photos: File[]): Promise<DailyReport> => {
    const formData = new FormData();
    photos.forEach((photo) => {
      formData.append('photos', photo);
    });
    const response = await api.post<DailyReport>(
      `/daily-reports/${id}/photos`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },

  deletePhoto: async (reportId: number, photoId: number): Promise<void> => {
    await api.delete(`/daily-reports/${reportId}/photos/${photoId}`);
  },

  deleteDocument: async (documentId: number): Promise<void> => {
    await api.delete(`/daily-reports/documents/${documentId}`);
  },
};
